/**
 * Wasiyat bootstrap. Registers components, decides phase, paints chrome.
 */
import './components/gate.ts';
import './components/onboarding.ts';
import './components/masthead.ts';
import './components/readiness-dial.ts';
import './components/asset-vault.ts';
import './components/nominee-registry.ts';
import './components/last-wishes.ts';
import './components/dead-man-switch.ts';
import './components/document-vault.ts';
import './components/crypto-vault.ts';
import './components/subscription-map.ts';
import './components/insights.ts';
import './components/handover-card.ts';
import './components/pricing-card.ts';
import './components/connector-shelf.ts';
import './components/zkp-section.ts';

import { store } from './store.ts';
import { loadEnvelope } from './chassis/storage.ts';

async function bootstrap(): Promise<void> {
  const env = await loadEnvelope();
  if (!env) {
    store.patch({ phase: 'onboarding' });
  } else {
    store.patch({ phase: 'gate' });
  }
  paintShell();
  registerSW();
}

function paintShell(): void {
  store.subscribe((s) => {
    const gate = document.querySelector('wasiyat-gate') as HTMLElement | null;
    const onboarding = document.querySelector('wasiyat-onboarding') as HTMLElement | null;
    const app = document.getElementById('app') as HTMLElement | null;
    if (!gate || !onboarding || !app) return;
    gate.hidden = s.phase !== 'gate';
    onboarding.hidden = s.phase !== 'onboarding';
    app.hidden = s.phase !== 'ready';
  });
}

function registerSW(): void {
  if ('serviceWorker' in navigator) {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  }
}

void bootstrap();
